var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurchaseReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8668 5.27999V8.71334C12.8668 10.7667 11.6935 11.6466 9.93347 11.6466H4.07347C3.77347 11.6466 3.4868 11.62 3.22013 11.56C3.05347 11.5334 2.89347 11.4867 2.74681 11.4333C1.74681 11.06 1.14014 10.1933 1.14014 8.71334V5.27999C1.14014 3.22666 2.31347 2.34668 4.07347 2.34668H9.93347C11.4268 2.34668 12.5001 2.98001 12.7868 4.42668C12.8335 4.69334 12.8668 4.96666 12.8668 5.27999Z",
    stroke: "#1E293B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8674 7.28007V10.7134C14.8674 12.7668 13.694 13.6467 11.934 13.6467H6.07404C5.5807 13.6467 5.13404 13.5801 4.74738 13.4334C3.95404 13.1401 3.41404 12.5334 3.2207 11.5601C3.48737 11.6201 3.77404 11.6467 4.07404 11.6467H9.93404C11.694 11.6467 12.8674 10.7668 12.8674 8.71342V5.28007C12.8674 4.96674 12.8407 4.68676 12.7874 4.42676C14.054 4.69342 14.8674 5.58674 14.8674 7.28007Z",
    stroke: "#1E293B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99927 8.75993C7.97129 8.75993 8.75928 7.97194 8.75928 6.99992C8.75928 6.02789 7.97129 5.23991 6.99927 5.23991C6.02725 5.23991 5.23926 6.02789 5.23926 6.99992C5.23926 7.97194 6.02725 8.75993 6.99927 8.75993Z",
    stroke: "#1E293B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.18701 5.53333V8.46667",
    stroke: "#1E293B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8145 5.53353V8.46688",
    stroke: "#1E293B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaseReport);
export default __webpack_public_path__ + "static/media/PurchaseReport.65a774c7efceb47c736a4c57140a1093.svg";
export { ForwardRef as ReactComponent };